import ProjectCompletedReminderModalComponent from './project-completed-reminder-modal.component'

const ProjectCompletedReminderModalModule = angular.module('cdbl.project-completed-reminder-modal', [

])
  .component('cdblProjectCompletedReminderModal', ProjectCompletedReminderModalComponent)
  .name

export default ProjectCompletedReminderModalModule
